import React, {PureComponent} from 'react';
import Select from 'react-select';
import {RoundIndicator} from "../Dashboard/RoundIndicator";
import DocumentService from "../../services/document.service";
import {DocumentRowFilterType, IDocumentRowSum} from "../../models/document-row";
import {AuthenticationContext} from "../../services/context/authentication.context";
import DateRangePicker, { DateRangeInput } from 'components/DateRangePicker/DateRangePicker';
import { DATE_PRESET_OPTIONS } from 'models/calendar';
import { selectTheme } from 'components/CustomerCards/CustomerCardsSearchBar';
import CustomerCardService from 'services/customer-card.service';
import { ICustomerCard } from 'models/customer-card';
import { IPageResponse } from 'common/interfaces/IPageResponse';
import PetrolStationService from '../../services/petrol-station.service';
import { Button, Spinner } from 'react-bootstrap';

interface IDocumentRowsSearchBarState {
    customerId: number | null;
    documentDateCreatedStart: string | any;
    documentDateCreatedEnd: string | any;
    cards: any;
    names: any;
    locations: any;
    vehicleNumbers: any;
    sumData: IDocumentRowSum | null;
}

const selectStyle = {
    indicatorSeparator: () => (
        {
            backgroundColor: 'red',
            width: '50px',
        }
    ),
};


export class DocumentRowSearchBar extends PureComponent<any, IDocumentRowsSearchBarState> {

    static contextType = AuthenticationContext;
    constructor(props: any) {
        super(props);
        this.state = {
            customerId: null,
            documentDateCreatedStart: null,
            documentDateCreatedEnd: null,
            cards: [],
            names: [],
            locations: [],
            vehicleNumbers: [],
            sumData: null
        };

    }
    getDocumentRowSums = () => {
        if (this.state.customerId === null)
            return;

        DocumentService.getDocumentRowsSum(this.state.customerId).then(
            (sumData: IDocumentRowSum) => {
                this.setState({
                    sumData: sumData
                })
            }
        ).catch(error => {
            this.setState({
                sumData: null
            })
        })
    };
    getCustomerPaymentCards = () => {
        if (this.state.customerId === null)
            return;

        CustomerCardService.getCustomerCards(this.state.customerId, null, {
            page: 0,
            size: 9000,
            isBlockedCard: false
        }).then((response: IPageResponse<ICustomerCard>) => {
            this.assignCardsToState(response.content);
        });
    };

    getLocations = () => {
        if (this.state.customerId === null)
            return;

        PetrolStationService.getCustomerStations(this.state.customerId, {
            page: 0,
            size: 100
        }).then((response: { nameEt: string }[]) => {
            this.setState({
                locations: response.map(c => ({
                    label: c.nameEt,
                    value: c.nameEt
                }))
            });
        });
    };

    getVehicleNumbers = () => {
        if (this.state.customerId === null)
            return;

        DocumentService.getDocumentsVehicleNumbers(this.state.customerId
        ).then((response: { number: string }[]) => {
            this.setState({
                vehicleNumbers: response.map(c => ({
                    label: c.number,
                    value: c.number
                }))
            });
        });
    };

    assignCardsToState(cards: ICustomerCard[]) {
        const namesOpts = [];
        const cardsOpts = [];
        for (const card of cards) {
            cardsOpts.push({
                label: card.remoteCardId,
                value: card
            })
            if (card.name && namesOpts.indexOf(card.name) === -1) {
                namesOpts.push(card.name);
            }
        }
        this.setState({
            cards: cardsOpts,
            names: namesOpts.map(n => ({ label: n, value: n}))
        })
    } 
    componentDidMount(): void {
        // this.getDocumentRowSums();
        this.getCustomerPaymentCards();
        this.getLocations();
        this.getVehicleNumbers();
    }

    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<IDocumentRowsSearchBarState>, snapshot?: any): void {
        if (this.context.state.customerId !== this.state.customerId) {
            this.setState({
                ...this.state,
                customerId: this.context.state.customerId,
            }, () => {
                // this.getDocumentRowSums()
                this.getCustomerPaymentCards();
                this.getLocations();
                this.getVehicleNumbers();
            });
        }
    }

    onDatesChange = (dates: DateRangeInput) => {
        this.props.onFilterChange(DocumentRowFilterType.DATE, dates);
    }

    render() {
        return (
            <div className="bar-position">
                <h2>
                    Väljavõte
                </h2>
                <div className="card mb-5">
                    <div className="card-body ">
                        <div className='d-flex flex-wrap flex-xl-nowrap flex-column flex-md-row document-rows__search-bar align-items-stretch align-items-md-center'>
                            <div className="mw-160-px mr-md-4 filter">
                                <DateRangePicker 
                                    startDate={this.props.filters[DocumentRowFilterType.DATE].startDate}
                                    endDate={this.props.filters[DocumentRowFilterType.DATE].endDate}
                                    onChange={this.onDatesChange}
                                    selectedOptionId={this.props.filters[DocumentRowFilterType.DATE].id}
                                    dateOptions={DATE_PRESET_OPTIONS}
                                />
                            </div>
                            <Select
                                options={this.state.cards}
                                style={selectStyle}
                                value={this.props.filters[DocumentRowFilterType.CARD]}
                                isClearable={true}
                                onChange={(val) => this.props.onFilterChange(DocumentRowFilterType.CARD, val)}
                                className='mw-192-px mr-md-4 invoices__select filter'
                                placeholder='Vali kaart'
                                theme={selectTheme}
                            />
                            <Select
                                options={this.state.names}
                                style={selectStyle}
                                value={this.props.filters[DocumentRowFilterType.NAME]}
                                isClearable={true}
                                onChange={(val) => this.props.onFilterChange(DocumentRowFilterType.NAME, val)}
                                className='mw-160-px mr-md-4 invoices__select filter'
                                placeholder='Vali nimi'
                                theme={selectTheme}
                            />                            
                            <Select
                                options={this.state.locations}
                                style={selectStyle}
                                value={this.props.filters[DocumentRowFilterType.LOCATION]}
                                isClearable={true}
                                onChange={(val) => this.props.onFilterChange(DocumentRowFilterType.LOCATION, val)}
                                className='mw-160-px mr-md-4 invoices__select filter'
                                placeholder='Vali tankla'
                                theme={selectTheme}
                            />
                            {this.state.vehicleNumbers.length ? <Select
                                options={this.state.vehicleNumbers}
                                style={selectStyle}
                                value={this.props.filters[DocumentRowFilterType.VEHICLE_NUMBER]}
                                isClearable={true}
                                onChange={(val) => this.props.onFilterChange(DocumentRowFilterType.VEHICLE_NUMBER, val)}
                                className='mw-160-px mr-md-4 invoices__select filter'
                                placeholder='Vali autonumber'
                                theme={selectTheme}
                            /> : null}
                            {
                                this.state.sumData &&
                                <div className="document-rows-indicator__container ml-auto d-none d-xl-flex">
                                    <RoundIndicator
                                        backgroundColor={'white'}
                                        outerRadius={75}
                                        innerRadius={65}
                                        innerRadiusFullShadow={true}
                                        fillPercentage={359.9}
                                        fillText={this.state.sumData ? this.state.sumData.sum + '' : ''}
                                        showfillPercentage={false}
                                        fillColor={'#008C9A'}
                                        description={"KM-ta " + this.state.sumData.sumWithoutVat.toFixed(1) + " €"}
                                        descriptionSecondLine={"KM: " + this.state.sumData.vatSum.toFixed(1) + " €"}
                                    />
                                </div>
                            }
                            {
                                !window.ReactNativeWebView ? (
                                    <div className="d-flex align-items-center document-rows__actions">
                                        <Button size="sm" variant="link" className="d-flex align-items-center px-1 ml-auto btn-outline-icon position-relative" onClick={() => this.props.getDocumentRowsXlsx()}>
                                            {
                                                this.props.downloadingDocumentXlsx ?
                                                <Spinner size="sm" animation="border" /> :
                                                <div className="" style={{ color: 'black' }}>
                                                    <div className='icon__download action-icon mb-2 icon--16' />
                                                    <span style={{ position: 'absolute', fontSize: '8px', bottom: '-3px', left: '2px'}}>XLSX</span>                            
                                                </div>
                                            }
                                        </Button>
                                        <Button size="sm" variant="link" className="d-flex align-items-center px-1 ml-1 btn-outline-icon position-relative" onClick={() => this.props.getDocumentRowsPdf()}>
                                            {
                                                this.props.downloadingDocumentPdf === true ?
                                                <Spinner size="sm" animation="border" /> :
                                                <div className="" style={{ color: 'black' }}>
                                                    <div className='icon__file action-icon mb-2 icon--16' />
                                                    <span style={{ position: 'absolute', fontSize: '8px', bottom: '-3px', left: '4px'}}>PDF</span>
                                                </div>
                                            }
                                        </Button>
                                    </div>
                                ) : null
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

